/**
 * Page de configuration 2FA - React Vite
 */

import { useNavigate } from 'react-router-dom';
import { TOTPSetupForm } from '../components/forms/TOTPSetupForm';
import { EmailSetupForm } from '../components/forms/EmailSetupForm';
import { useState } from 'react';
import { useAuth } from '../hooks/useAuth';

type SetupMethod = 'totp' | 'email';

export function TwoFactorSetupPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [method, setMethod] = useState<SetupMethod>('totp');

  const handleSuccess = () => {
    navigate('/dashboard');
  };

  const handleSkip = () => {
    navigate('/dashboard');
  };

  // Récupérer l'ID utilisateur depuis le store auth
  const userId = user?.id || (user as any)?.idUtilisateur || '';

  if (!userId) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p>Chargement...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-raised py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-content">
            Configurer la double authentification
          </h2>
          <p className="mt-2 text-center text-sm text-content-muted">
            Sécurisez votre compte avec une vérification en deux étapes
          </p>
        </div>

        {/* Sélection de la méthode */}
        <div className="flex justify-center space-x-4 mb-6">
          <button
            onClick={() => setMethod('totp')}
            className={`px-4 py-2 rounded-lg ${
              method === 'totp'
                ? 'bg-primary text-content-inverted'
                : 'bg-surface-overlay text-content-muted'
            }`}
          >
            Application TOTP
          </button>
          <button
            onClick={() => setMethod('email')}
            className={`px-4 py-2 rounded-lg ${
              method === 'email'
                ? 'bg-primary text-content-inverted'
                : 'bg-surface-overlay text-content-muted'
            }`}
          >
            Email
          </button>
        </div>

        <div className="bg-surface rounded-lg shadow-lg p-8">
          {method === 'totp' ? (
            <TOTPSetupForm userId={userId} onSuccess={handleSuccess} />
          ) : (
            <EmailSetupForm userId={userId} onSuccess={handleSuccess} />
          )}

          <div className="mt-6 text-center">
            <button
              onClick={handleSkip}
              className="text-sm text-content-subtle hover:text-content"
            >
              Configurer plus tard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TwoFactorSetupPage;
